// removed by extract-text-webpack-plugin
module.exports = {"icon":"Loading__icon__bth2O","pulse":"Loading__pulse__EI7s5","fadein":"Loading__fadein__1rzVm"};


//////////////////
// WEBPACK FOOTER
// ./src/Loading/Loading.css
// module id = 60
// module chunks = 0